/**
 * Errores tipados del perfil de la sesión (edición de datos de cuenta, LION-761).
 *
 * `AuthStore.updateProfile()` lo lanza para que la pantalla pueda ramificar la UI
 * sin parsear status codes: la validación del nombre (400 — vacío/espacios/>120)
 * se muestra con el mensaje amigable que transporta este error. El servidor es la
 * autoridad; el cliente sólo hace una validación previa por UX.
 */

/**
 * El nombre no cumple la validación del servidor (HTTP 400): vacío, sólo espacios
 * o más de 120 caracteres. `message` trae un texto apto para mostrar al usuario
 * (el del backend si vino, o uno por defecto).
 */
export class ProfileValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ProfileValidationError';
  }
}
